import { Skeleton } from '@mui/material'
import { memo } from 'react'

const FoundersKeyLoading = () => {
  return (
    <>
      <Skeleton variant='text' width={180} height={24} />
      <Skeleton variant='text' width={200} height={24} />
      <Skeleton variant='text' width={230} height={24} />
    </>
  )
}

export default memo(FoundersKeyLoading)
